import React from 'react';
import styles from './loader.module.scss';
import { cn } from '../../helpers/className';
import { Spinner } from '..';

interface ILoaderProps {
    show: boolean;
    size: string;
    position?: string;
    className?: string;
}

export const Loader = ({ size, className, show, position }: ILoaderProps): JSX.Element => {
    const classes = cn(styles.loader, styles[size], className, {
        [styles[position]]: position,
    });

    if (!show) {
        return null;
    }

    return <Spinner className={classes} />;
};
